import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Props for the TransactionBuilderFooter component
 */
interface TransactionBuilderFooterProps {
  onContinue?: () => void;
  continueButtonText?: string;
  continueButtonDisabled?: boolean;
  showContinueButton?: boolean;
  embedded?: boolean;
  continueIcon?: boolean;
  secondaryAction?:
    | {
        label: string;
        onClick: () => void;
        disabled?: boolean;
        icon?: React.ReactNode;
      }
    | undefined;
}

/**
 * Footer component for the transaction builder
 * Displays the continue button
 */
export function TransactionBuilderFooter({
  onContinue,
  continueButtonText = 'Continue',
  continueButtonDisabled = false,
  showContinueButton = true,
  secondaryAction,
  embedded = false,
  continueIcon = true,
}: TransactionBuilderFooterProps): React.ReactElement {
  return (
    <div
      className={cn(
        'bottom-0 left-0 right-0 z-50 shrink-0 bg-background border-t',
        embedded ? 'sticky' : 'fixed'
      )}
    >
      <div className="flex min-h-[74px] flex-wrap justify-center items-center gap-2.5 p-2.5">
        {secondaryAction && (
          <Button
            type="button"
            variant="outline"
            onClick={secondaryAction.onClick}
            disabled={secondaryAction.disabled}
            className="h-[37px] gap-2.5 rounded-[9px] px-[19px] text-sm font-semibold has-[>svg]:px-[19px]"
          >
            {secondaryAction.icon}
            {secondaryAction.label}
          </Button>
        )}
        {showContinueButton && (
          <Button
            type="button"
            variant="default"
            onClick={onContinue}
            disabled={continueButtonDisabled}
            className="h-[37px] gap-2.5 rounded-[9px] px-[19px] text-sm font-semibold has-[>svg]:px-[19px]"
          >
            {continueButtonText}
            {continueIcon && (
              <ArrowRight className="size-[15px]" aria-hidden="true" />
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
